import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { vendorCheckout } from "../lib/api";

export const STARTER_PERKS = [
  "your logo next to your name — on your page and across the browse/list pages (free listings stay text-only)",
  "your own button — set the link and label (\"start free trial\", \"book a demo\"), direct to your site",
  "an expanded listing page — screenshots, a video, a short \"why us vs the alternatives\" in your words, integrations list",
  "rank badges for your site — \"#3 Screener on TerminalValue.io\", \"Top 10 · Value Investing\"",
];

const EDGAR_LOGO = "https://www.edgarreader.com/icon.svg";

export default function StarterUpgrade({ slug, plan }) {
  const [busy, setBusy] = useState("");
  if (plan === "starter")
    return (
      <div className="border border-black p-3 text-[13px]" data-testid="starter-active">
        ★ this listing is on <b>Starter</b>.
      </div>
    );
  const go = async (key) => {
    setBusy(key);
    try {
      const r = await vendorCheckout(slug, key);
      window.location.href = r.checkout_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "could not start checkout");
      setBusy("");
    }
  };
  return (
    <section className="border border-black p-3" data-testid="starter-upgrade">
      <h2 className="text-[15px] font-bold">upgrade to Starter</h2>
      <p className="text-[12px] text-[#666] mt-1">founding price — 50% off your first year · $99/mo or $990/yr from year two</p>
      <ul className="mt-2 pl-5 list-disc text-[13px] leading-relaxed">
        {STARTER_PERKS.map((p) => <li key={p}>{p}</li>)}
      </ul>

      <div className="mt-3 border border-black bg-[#f6f6f6] p-3" data-testid="starter-logo-preview">
        <div className="text-[14px] font-bold">see a live Starter listing</div>
        <div className="text-[11px] text-[#888] mt-1">
          here's how your row looks in the list — your logo sits inline, left of the name (free listings are text-only). click EdgarReader to open the full listing.
        </div>
        <ul className="mt-2 bg-white border border-black px-3">
          <li className="flex items-start gap-3 py-3">
            <div className="flex flex-col items-center w-10 select-none pt-0.5">
              <span className="tv-upvote">▲</span>
              <span className="text-[11px] mt-1 tabular-nums">1</span>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-baseline gap-3 flex-wrap">
                <img
                  src={EDGAR_LOGO}
                  alt=""
                  loading="lazy"
                  className="w-[18px] h-[18px] object-contain border border-black bg-white p-[1px] self-center shrink-0"
                  data-testid="starter-logo-preview-img"
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
                <Link
                  to="/tool/edgarreader"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tv-link text-base font-semibold break-words"
                  data-testid="starter-logo-preview-link"
                >
                  EdgarReader
                </Link>
                <span className="text-[12px] text-[#888]">(edgarreader.com ↗)</span>
                <span className="ml-auto text-[12px] font-bold tabular-nums whitespace-nowrap">FREE-$$</span>
              </div>
              <div className="text-[13px] text-[#222] mt-0.5">
                Every SEC filing, word for word, beautifully laid out, with graphs of what you're reading and smart tables.
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        <button type="button" className="tv-btn tv-btn-primary" disabled={!!busy} onClick={() => go("starter_monthly")} data-testid="starter-monthly-btn">
          {busy === "starter_monthly" ? "…" : "[$49 / month — first year]"}
        </button>
        <button type="button" className="tv-btn" disabled={!!busy} onClick={() => go("starter_yearly")} data-testid="starter-yearly-btn">
          {busy === "starter_yearly" ? "…" : "[$495 / year — first year, 2 months free]"}
        </button>
      </div>
      <p className="text-[11px] text-[#888] mt-2">cancel anytime · card via Stripe</p>
    </section>
  );
}
